import { PaymentPlanDetailResult } from '@mews-commander/data-access';
import { Stack } from '@optimus-web/core';
import { WithAccountId } from '@mews-commander/types';
import { Breadcrumbs, useBreadcrumbs } from '@mews-commander/ui';
import { isPaymentPlanCancellable } from '../../tables/PaymentPlans/utils';
import { WithPaymentPlanId } from '../../tables/PaymentPlans/types';
import { PaymentPlanDetailsCancelPlan } from './PaymentPlanDetailsCancelPlanSection';

interface Props extends WithAccountId, WithPaymentPlanId {
    detail: PaymentPlanDetailResult;
}

export const PaymentPlanDetailsViewHeader = ({ detail, accountId, paymentPlanId }: Props) => {
    const breadcrumbs = useBreadcrumbs();

    const isCancellable = isPaymentPlanCancellable(detail?.status);

    return (
        <Stack spacing="200" itemAlignment="center" distribution="space-between">
            <Breadcrumbs breadcrumbs={breadcrumbs} />
            <Stack spacing="150" itemAlignment="center">
                {isCancellable && (
                    <PaymentPlanDetailsCancelPlan
                        paymentPlanId={paymentPlanId}
                        accountId={accountId}
                        paymentMethodData={detail?.paymentMethodData}
                    />
                )}
            </Stack>
        </Stack>
    );
};
